

















































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import CustomerDetail from "../../../store/entities/customers/customer-detail";
import Address from "../../../store/entities/address";
import AddressModal from "../../components/address-modal.vue";
import _ from "lodash";
import util from "../../../lib/util";
import AppConsts from "@/lib/appconst";
Vue.use(require("vue-moment"));

@Component({
  components: { AddressModal },
})
export default class UpdateCustomer extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  code: string = "";
  addressModalShow: boolean = false;
  customer: CustomerDetail = new CustomerDetail();
  spinShow: boolean = false;
  selectedAddress: Address = new Address();
  customerAddress: Address = null;
  types = [];
  tplCode: string = null;
  tpl = { totalWeight: null, totalVolume: null };
  tplLoading: boolean = false;
  tpls = [];
  isClient() {
    return this.$store.state.session.client != null;
  }
  searchTpl_OnPress = _.debounce(this.searchTpls, AppConsts.debounceDelayTime, {
    leading: false,
    trailing: true,
  });
  async searchTpls(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.tplLoading = true;
    this.$store
      .dispatch({
        type: "tpl/searchTplForSelect",
        data: {
          keyWord: keyword,
        },
      })
      .then((result) => {
        this.tpls = result;
        this.tplLoading = false;
      });
  }
  async getTypes() {
    await this.$store
      .dispatch({
        type: "customerType/getCustomerType",
        data: { hasAllItem: false },
      })
      .then((result) => {
        this.types = result;
      });
  }
  updateAddress() {
    if (
      _.isNil(this.customerAddress) ||
      util.addressDiff(this.customerAddress, this.selectedAddress)
    ) {
      this.customer.customerAddress = this.selectedAddress;
    } else {
      this.customer.customerAddress = null;
    }
  }
  openModalAddress() {
    this.addressModalShow = true;
  }
  async save() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.UpdateCustomer"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          var updateCustomer = {
            id: this.customer.id,
            code: this.customer.code,
            name: this.customer.name,
            type: this.customer.type,
            phone: this.customer.phone,
            taxNumber: this.customer.taxNumber,
            receiver: this.customer.receiver,
            address: this.customer.customerAddress,
            defaultTPLCode: null,
          };
          if (!_.isNil(this.tplCode) && !_.isEmpty(this.tplCode)) {
            updateCustomer.defaultTPLCode = this.tplCode;
          }
          await this.$store
            .dispatch({
              type: "customer/update",
              data: updateCustomer,
            })
            .then((result) => {
              Util.showSuccessMsg(this, "Success.UpdateCustomer");
              this.reset();
              this.onGoBack();
            });
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  onGoBack() {
    this.$root.$router.push({ name: "customer" });
  }
  async getInfo() {
    await this.$store
      .dispatch({
        type: "customer/getCustomerByKeyword",
        data: {
          keyWord: this.code,
        },
      })
      .then((res) => {
        var type = res.type;
        this.customer = res;
        this.selectedAddress = this.customer.customerAddress;
        this.customerAddress = { ...this.customer.customerAddress };
        this.customer.customerAddress = null;
        this.tplCode = this.customer.defaultTPLCode;
      });
  }
  reset() {
    this.spinShow = false;
    this.addressModalShow = false;
    this.customer = new CustomerDetail();
    this.selectedAddress = new Address();
    this.customerAddress = new Address();
    this.code = "";
    this.customerAddress = null;
    this.tplCode = null;
    this.tpls = [];
  }

  async created() {
    this.spinShow = true;
    try {
      this.code = this.$root.$router.currentRoute.params.code;
      await this.getTypes();
      await this.getInfo();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }

  customerRule = {
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
    type: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Type")),
        trigger: "blur",
      },
    ],
    fullAddress: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Address")),
        trigger: "blur",
      },
    ],
  };
}
